import * as TogglePrimitive from "@radix-ui/react-toggle"
import { forwardRef, type ReactNode } from "react"

import { Button } from "../Button"
import { useButtonGroup } from "../ButtonGroup"
import type { IconName } from "../Icon"

export interface ToggleButtonProps {
  children?: ReactNode
  disabled?: boolean
  size?: "small" | "medium" | "large"
  color?: "grey" | "dark" | "purple"
  startIcon?: IconName
  endIcon?: IconName
  pressed?: boolean
  onPressedChange?: (pressed: boolean) => void
  hiddenLabel?: string
}

export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  function ToggleButton(props, ref) {
    const buttonGroup = useButtonGroup()

    const {
      children,
      disabled = buttonGroup?.disabled,
      size = buttonGroup?.size ?? "medium",
      color = buttonGroup?.color ?? "purple",
      startIcon,
      endIcon,
      pressed,
      onPressedChange,
      hiddenLabel,
      ...implicitProps
    } = props

    return (
      <TogglePrimitive.Root
        {...implicitProps}
        asChild
        disabled={disabled}
        ref={ref}
        pressed={pressed}
        onPressedChange={onPressedChange}
      >
        <Button
          size={size}
          color={color}
          startIcon={startIcon}
          endIcon={endIcon}
          hiddenLabel={hiddenLabel}
        >
          {children}
        </Button>
      </TogglePrimitive.Root>
    )
  },
)
